var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"show-scrollbar",staticStyle:{"max-height":"calc(var(--vh) - 50px)","overflow-y":"auto"}},[_c('notifications')],1)}
var staticRenderFns = []

export { render, staticRenderFns }